interface Props {
  title: string
}

const BrandTitle = ({ title }: Props) => (
  <p className="text-sm font-natosans-bold text-[#333333] my-2.5">{title}</p>
)

export default BrandTitle
